// extracted by mini-css-extract-plugin
module.exports = {"efaxOrdersLabel":"InboxSidebar_efaxOrdersLabel__2Fdw2","unassignedEfaxes":"InboxSidebar_unassignedEfaxes__3En0Y"};